export enum AuthScheme {
  Bearer = 'Bearer',
}
